module.exports = __webpack_public_path__ + "img/content_title3.f0e7866a.png";